import { CwtApiEntity, CwtModel, CwtProp } from "@cawita/core-front/api";

@CwtModel({ name: 'company-answers' })
export class CompanyAnswers extends CwtApiEntity {
    @CwtProp() workAffectsSleepQuality: string[];
    @CwtProp() jobStressImpactsSleep: string[];
    @CwtProp() personalEventsDisruptSleep: string[];
    @CwtProp() tensionsWithColleaguesOrManagement: string[];
    @CwtProp() tensionsWithClientsOrPartners: string[];
    @CwtProp() workOverload: string[];
    @CwtProp() careerUncertainty: string[];
    @CwtProp() personalConcernsAffectWork: string[];
    @CwtProp() physicalPainContributors: string[];
    @CwtProp() sportPracticeLimitations: string[];
    @CwtProp() mentalLoadFactors: string[];
}